import { contentfulPageToComponentsProps } from '@utils/contentful/contentfulPageToComponentsProps'
import { Entry } from 'contentful'
import { TContentfulComponents } from 'types/contentful/contentfulComponents'
import { IGenericReferenceBlock } from 'types/contentful/genericReferenceBlock'
import * as Sentry from '@sentry/nextjs'
export interface IContentfulConfigurableAccordion {
  title: string
  sections: Entry<IGenericReferenceBlock<any>>[]
}

export interface IConfigurableAccordion {
  componentKey: 'configurableAccordion'
  sections: {
    id: string
    title: string
    components: TContentfulComponents[] | any[]
  }[]
}

export const parseConfigurableAccordion = async (
  accordionEntry: Entry<IContentfulConfigurableAccordion>
): Promise<IConfigurableAccordion> => {
  if (!accordionEntry?.fields?.sections) {
    return {
      componentKey: 'configurableAccordion',
      sections: [],
    }
  }

  return {
    componentKey: 'configurableAccordion',
    sections: await Promise.all(
      accordionEntry?.fields?.sections?.map(async (section) => {
        if (
          !section?.sys?.id ||
          !section?.fields?.primaryReferences ||
          !section?.fields?.displayName
        ) {
          Sentry.captureException(
            'Accordion section is missing details. Id, primary references and display name are required.',
            { extra: { section } }
          )
          return null
        }

        return {
          id: section?.sys?.id,
          title: section.fields.displayName,
          components: await contentfulPageToComponentsProps({
            contentfulPageComponents: section.fields.primaryReferences,
            dataForParsers: {
              categories: [],
              parentSlug: 'custom-packaging',
              preview: false,
            },
          }),
        }
      })
    ),
  }
}
